var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "eu-mb_5" },
    [
      _c("p", { staticClass: "emd-text _color_subtle _type_caption eu-mb_1" }, [
        _vm._v(" " + _vm._s(_vm.title) + " "),
      ]),
      _vm.showCustomersDetail
        ? _c(
            "router-link",
            {
              staticClass: "emd-link fs-hide",
              attrs: { to: { name: "customersDetail", params: _vm.params } },
            },
            [_vm._t("default")],
            2
          )
        : _c("p", { staticClass: "emd-text fs-hide" }, [_vm._t("fallback")], 2),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }